import * as yup from 'yup';

export const importEmployeesPayCalendarFormSchema = yup.object().shape({
  payCalendarId: yup.string().required('You need to select a pay calendar'),
});

export const importEmployeesUploadFormSchema = yup.object().shape({
  bulkImportId: yup.string().required('You need a bulk import to advance'),
  bulkImportStatus: yup.string().required('You need a bulk import to advance'),
});
